import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/server/builds/landing-2025-04-22-14-33/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/server/builds/landing-2025-04-22-14-33/layouts/empty.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/home/server/builds/landing-2025-04-22-14-33/layouts/landing.vue").then(m => m.default || m)),
  old: defineAsyncComponent(() => import("/home/server/builds/landing-2025-04-22-14-33/layouts/old.vue").then(m => m.default || m))
}